<template>
  <div id="corp-config-modal" class="modal" v-show="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main" >
      <div class="title-area" id="modal-moving">
        <div
          class="cross_btn"
          @click="closeModal"
        >
          <span class="css-cancel"></span>
        </div>
        <h2>企業メニュー</h2>
      </div>
      <div class="data-area">
        <button type="button" class="conf_btn" v-show="!dispTrialUserTools" @click="onClickCorpInfo">登録情報設定</button>
        <button type="button" class="conf_btn" v-show="!dispTrialUserTools" @click="onClickUserManage">ユーザー管理</button>
        <button type="button" class="conf_btn" @click="onClickSystemConfig">システム設定</button>
        <button type="button" class="conf_btn" v-show="!dispTrialUserTools" @click="onClickCostCustomConfig">価格カスタム名設定</button>
        <button type="button" class="conf_btn" @click="onClickEstimateConfig">見積り設定</button>
        <button type="button" class="conf_btn" @click="onClickNestingConfig">ネスティング設定</button>
        <button type="button" class="conf_btn" v-show="!dispTrialUserTools">図面設定</button>
        <button type="button" class="conf_btn" v-show="!dispTrialUserTools" @click="onClickBomCustomConfig">構成明細カスタム名設定</button>
        <button type="button" class="conf_btn" v-show="!dispTrialUserTools" @click="onClickOrderList" v-if="isUseOrder">受注リスト</button>
        <button type="button" class="conf_btn" v-show="!dispTrialUserTools" @click="onClickEditingFile">編集中ファイル強制解除</button>
      </div>
    </div>
  </div>
</template>
<script>
import * as App from '../../utils/App'
import {LICENSE_TYPE} from '../../constants/Type'
export default {
  name: 'CorpConfigModal',
  data () {
    return {
      /** モーダル判定 */
      modalShown: false
    }
  },
  props: {
    routeOrderList: {
      type: Function,
      default: function () {}
    },
    onCancel: {
      type: Function,
      default: function () {}
    },
    callbackParams: {
      type: Object,
      default: function () { return {} }
    }
  },
  watch: {
    modalShown: function () {
      /** キャンバス内キーボード制御 */
      if (this.modalShown) {
        // this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        // this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  computed: {
    isUseOrder: function () {
      let user = App.getUserInfo()
      return user && user.menuServiceCode.debugOrder
    },
    dispTrialUserTools: function () {
      let user = App.getUserInfo()
      return user && LICENSE_TYPE.TRIAL === user.licenseType
    }
  },
  methods: {
    /** モーダル表示 */
    showModal: function () {
      this.modalShown = true
    },
    closeModal: function () {
      this.onCancel(this.callbackParams)
      this.modalShown = false
    },
    onClickUserManage: function () {
      this.modalShown = false
      let modalData = {
        prevDialog: () => { this.modalShown = true }
      }
      App.showUserManageModal(modalData)
    },
    onClickEstimateConfig: function () {
      this.modalShown = false
      let modalData = {
        prevDialog: () => { this.modalShown = true }
      }
      App.showEstimateConfigModal(modalData)
    },
    onClickNestingConfig: function () {
      this.modalShown = false
      let modalData = {
        prevDialog: () => { this.modalShown = true }
      }
      App.showNestingConfigModal(modalData)
    },
    onClickSystemConfig: function () {
      this.modalShown = false
      let modalData = {
        prevDialog: () => { this.modalShown = true }
      }
      App.showSystemConfigModal(modalData)
    },
    onClickCostCustomConfig: function () {
      this.modalShown = false
      let modalData = {
        prevDialog: () => { this.modalShown = true }
      }
      App.showCostCustomConfigModal(modalData)
    },
    onClickBomCustomConfig: function () {
      this.modalShown = false
      let modalData = {
        prevDialog: () => { this.modalShown = true }
      }
      App.showBomCustomConfigModal(modalData)
    },
    onClickOrderList: function () {
      this.modalShown = false
      this.routeOrderList()
    },
    onClickCorpInfo: function () {
      this.modalShown = false
      let modalData = {
        prevDialog: () => { this.modalShown = true }
      }
      App.showCorpInfoModal(modalData)
    },
    onClickEditingFile: function () {
      this.modalShown = false
      let modalData = {
        prevDialog: () => { this.modalShown = true }
      }
      App.showEditingFileModal(modalData)
    }
  }
}
</script>
<style scoped>
.conf_btn {
  background: rgb(255,255,255);
  border: 1px solid rgba(0, 0, 0, 0.2);
  line-height: 30px;
  margin-bottom: 10px;
  cursor: pointer;
  padding: 0;
  width: 60%;
  letter-spacing: 2px;
  outline: 0;
}
.conf_btn:hover{
  color: rgb(255, 69, 0);
  border: 1px solid rgba(255, 69, 0, 0.8);
}
.title-area {
  display: flex;
}
.data-area {
  padding: 20px;
}
h2{
  margin: auto;
  padding-right: 29px;
}
/*==== 閉じるボタン ====*/
.cross_btn {
  width:19px;
  height:19px;
  padding: 3px 4px;
  /* position: absolute; */
  top:20px;
  left:30px;
  border: 1px solid #ff4500;
}
.cross_btn:hover {
  cursor: pointer;
}
.css-cancel {
  display: inline-block;
  position: relative;
  margin: 0 20px 0 7px;
  padding: 0;
  width: 3px;
  height: 20px;
  background: #000;
  transform: rotate(45deg);
  background: #ff4500;
}
.css-cancel:before {
  display: block;
  content: "";
  position: absolute;
  top: 50%;
  left: -8px;
  width: 20px;
  height: 3px;
  margin-top: -2px;
  background: #000;
  background: #ff4500;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/common/CorpConfigModal.vue